import { Button } from "../../ui/button";
import { ArrowRight, Calendar, Phone } from "lucide-react";
import { useSmoothNavigate } from "../../../utils/landing/useSmoothNavigate";

export function CallToAction() {
  const smoothNavigate = useSmoothNavigate();
  
  return (
    <section className="relative py-16 overflow-hidden bg-primary-custom">
      {/* Elementos decorativos */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full -translate-x-1/2 translate-y-1/2"></div>

      <div className="container relative z-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-10">
              <span className="text-white/90 flex items-center gap-2">
                <Calendar className="h-4 w-4" />
                Inscripciones abiertas 2025
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-10 text-white">
              Asegura un futuro brillante para tu hijo
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Con una educación de calidad basada en valores y excelencia
              académica, formamos líderes preparados para los desafíos del
              futuro.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              className="web-btn-main bg-white text-primary-custom hover:bg-white/90 px-8 py-6 text-lg group"
              onClick={(e) => smoothNavigate(e, "#contacto")}
            >
              <span className="mr-2">Solicitar información</span>
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="web-btn-outline border-white text-white hover:bg-white/10 hover:text-white px-8 py-6 text-lg group"
              onClick={() => {
                window.location.href = "tel:+51991234567";
              }}
            >
              <Phone className="h-5 w-5 mr-2" />
              <span>Llamar ahora</span>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
